const statistics = [
  { label: "Lĩnh vực thuốc bảo vệ thực vật", number: "15 năm+" },
  { label: "Tỉnh thành có mặt trong hệ thống phân phối", number: "63/63" },
  { label: "Đại lý và điểm bán trên toàn quốc", number: "2.000+" },
  { label: "Nông hộ đã và đang sử dụng sản phẩm", number: "500.000+" },
  {
    label: "Sản phẩm đạt tiêu chuẩn chất lượng cao, an toàn với môi trường",
    number: "100+",
  },
];

export default statistics;
